<template>
  <v-row v-if="instructorProfile" justify="center">
    <v-col cols="12">
      <v-card flat class="transparent">
        <v-card-text class="text-center pb-6">
          <v-avatar color="primary" size="150">
            <img
              v-if="instructorProfile.get('profilePicture')"
              :src="instructorProfile.get('profilePicture')"
              alt
            />
            <v-icon v-else dark>mdi-account-circle</v-icon>
          </v-avatar>
        </v-card-text>
        <v-card-title
          class="justify-center py-0 text-h5"
        >{{ instructorProfile.get('firstName') }} {{ instructorProfile.get('lastName') }}</v-card-title>
        <v-card-text class="text-center">{{ instructorProfile.get('schoolName') }}</v-card-text>
      </v-card>
    </v-col>
    <v-col cols="10">
      <v-card>
        <v-card-title class="primary white--text mb-4 justify-space-between">
          <v-btn color="light" small class="mr-2" @click="copyUrl">
            <v-icon left>mdi-share</v-icon>Share Profile
          </v-btn>
          <Appoinment />
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <!-- Email:
              <a :href="'mailto:' + instructorProfile.get('customEmail')">{{ instructorProfile.get('customEmail') }}</a>
              <br />
              Phone: <a :href="'tel:' +instructorProfile.get('phone')">{{ instructorProfile.get('phone') }}</a>-->
              <span v-if="instructorProfile.get('instructorCities')">
                Operates in the following citie(s):
                <b
                  v-for="(element, index) in instructorProfile.get('instructorCities')"
                  :key="index"
                >
                  <span v-if="index !== 0">,</span>
                  <span>{{ element }}</span>
                </b>
              </span>
            </v-col>

            <v-col>
              <!-- Just Make it school address -->
              <!-- <h4>{{ instructorProfile.get('schoolName') }}</h4>
              <address>
                {{ instructorProfile.get('addressOne') }}, {{ instructorProfile.get('city') }},
                <br />
                {{ instructorProfile.get('province') }}, {{ instructorProfile.get('postalCode') }},
                {{ instructorProfile.get('country') }}
              </address>-->
              <!-- <v-btn
                :href="`https://www.google.com/maps/search/?api=1&query=${instructorProfile.get('location').latitude},${instructorProfile.get('location').longitude}`"
                target="_blank"
                small
                class="mt-4"
              >
                <v-icon left>mdi-map-marker</v-icon>View on map
              </v-btn>-->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Appoinment from '@/components/account/profile/Appointment'
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: mapGetters(['instructorProfile', 'user']),
  components: { Appoinment },
  methods: {
    ...mapActions(['getInstructorProfile', 'toggleDialog']),
    async init () {
      // TODO: handle Error if id isn't valid
      await this.getInstructorProfile({ instructorId: this.id })
    },
    copyUrl () {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.value = window.location.href
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.toggleDialog({
        status: true,
        title: 'Copied!',
        message: 'Instructor\'s shareable link copied to clipboard!'
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
